import { UntypedFormControl, Validators } from '@angular/forms';
import { FileUploaderComponent } from '@platform500services/p500-ui-kit';
import { ActionConfigAbstract } from '../../services/actions/abstracts/action-config.abstract';
import { FieldModel } from '../../services/actions/models/field.model';

export class LastStepActionConfig extends ActionConfigAbstract {
  protected readonly key: string = 'AffiliateCrm\\AffiliateSteps\\Insert';
  protected readonly repository: string = 'Eloquent\\AffiliateStepsRepository';
  protected readonly title: string = '';
  protected readonly description: string = '';
  protected readonly fields: FieldModel[] = [
    new FieldModel('', 'data', FileUploaderComponent, new UntypedFormControl(null, Validators.required), {
      additional: $localize`:@@common.available_formats_png:Available formats: .PNG, .JPEG, .SVG, .PDF, .JPG`,
      accept: '.png, .jpeg, .svg, .pdf, .jpg',
    }),
  ];
}
